module.exports = __webpack_public_path__ + "img/logoProperty.58f55c5c.png";